import type { TExposedUserDTO } from '@doutorsim/shared/users'
import type { ColumnDef } from '@tanstack/react-table'
import { formatDate } from '../_helpers/date'
import { DeleteUserButton } from '../companies/[companyId]/users/_components/delete-user-button'
import { EditUserButton } from '../companies/[companyId]/users/_components/edit-user-button'
import { SendRecoveryPasswordEmailButton } from '../companies/[companyId]/users/_components/send-recovery-password-email-button'

type TUserWithCompany = TExposedUserDTO & {
  company: { id: string }
}

export const usersColumns: ColumnDef<TUserWithCompany>[] = [
  {
    accessorKey: 'name',
    header: 'Nome',
    cell: ({ row }) => {
      return <span className="px-8 py-3">{row.original.name}</span>
    },
  },
  {
    accessorKey: 'email',
    header: 'E-mail de acesso',
    cell: ({ row }) => {
      return <span className="px-8 py-3">{row.original.email}</span>
    },
  },
  {
    id: 'password-action',
    header: 'Senha',
    cell: ({ row }) => (
      <div className="px-8 py-3">
        <SendRecoveryPasswordEmailButton name={row.original.name} email={row.original.email} />
      </div>
    ),
  },
  {
    accessorKey: 'createdAt',
    header: 'Data de Criação',
    cell: ({ row }) => {
      return (
        <div className="px-11 py-3">
          <span>{row.original.createdAt ? formatDate(row.original.createdAt) : '—'}</span>
        </div>
      )
    },
  },
  {
    id: 'settings-action',
    cell: ({ row }) => {
      return (
        <div className="flex justify-center gap-3 px-8 py-3">
          {row.original.userType === 'integrator' && (
            <DeleteUserButton
              id={row.original.id}
              name={row.original.name}
              companyId={row.original.company?.id}
            />
          )}

          <EditUserButton
            id={row.original.id}
            name={row.original.name}
            email={row.original.email}
            companyId={row.original.company?.id}
          />
        </div>
      )
    },
  },
]
